import { combineReducers } from "redux";
import {reducer as formReducer} from 'redux-form';

import authentication from "../authentication/authenticationReducers";
import recorder, {recorderReduxFormPlugin} from "../recorder/recordingReducers";
import { SAVE_USER_DETAILS_FAILED } from "../authentication/actions/authenticationActions";
import reporting from "../compliance/uptake/reportingReducer";
import compliance from "../compliance/complianceReducer";
import { authenticationStatus } from "../disclosure/authentication/authenticationReducers";
import disclosures from "../disclosure/recommendations/disclosuresReducers";
import portal from "../disclosure/portal/portalReducers";
import {LOGOUT_SUCCESS} from "../authentication/actions/authenticationActions";

function clientAppVersion(state = "dev", action) {
    return global.clientAppVersion || "dev";
}

function messages(state = {}, action) {
    switch (action.type) {
        case SAVE_USER_DETAILS_FAILED:
            return { errors: ["Apologies, we're having trouble saving your details. You won't be able to record recommendations for now. Please wait while we fix this."] };
        default:
            return {};
    }
}

const appReducers = combineReducers({
    clientAppVersion,
    authentication,
    recorder,
    form: formReducer.plugin({
        recorder: recorderReduxFormPlugin
    }),
    authenticationStatus,
    disclosures,
    portal,
    messages,
    reporting,
    compliance
});


const rootReducer = (state, action) => {
    if (action.type === LOGOUT_SUCCESS) {
        state = undefined;
    }

    return appReducers(state, action);
};

export default rootReducer;




/** WEBPACK FOOTER **
 ** ./src/main/javascript/reducers/reducers.js
 **/